export {useUniqId} from './useUniqId';
export type {UseUniqIdResult} from './useUniqId';
